<template>
  <div class="tooltip">
    <el-tooltip placement="bottom" effect="light">
      <div slot="content">
        <!-- msg数组传参，多行展示 -->
        <p v-for="(item, index) in messages" :key="index">
          {{ item }}
        </p>
      </div>
      <!-- 可以做成自定义图标或者文案 -->
      <i class="el-icon-question tips-icon" style="color: #000;margin-left:-10px;" />
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'TableHeaderTip',
  props: {
    messages: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scope>
  .tooltip{display: inline-block;vertical-align: middle;}
</style>
